import { useQuery } from "@tanstack/react-query";
import { CheckCircle2, ExternalLink, XCircle } from "lucide-react";
import { api } from "@/api/client";
import { useAuth } from "@/auth/auth-context";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const QUEUES_URL = "https://api.sparesplc.com/admin/queues";

function HealthCard() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["health"],
    queryFn: api.health,
    refetchInterval: 30_000,
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>API</CardTitle>
        <CardDescription>Backend service status</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-6 w-24" />
        ) : isError ? (
          <Badge variant="destructive" className="gap-1.5">
            <XCircle className="size-3.5" />
            Unavailable
          </Badge>
        ) : (
          <Badge className="gap-1.5">
            <CheckCircle2 className="size-3.5" />
            {data?.status}
          </Badge>
        )}
      </CardContent>
    </Card>
  );
}

function SessionCard() {
  const { user } = useAuth();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Session</CardTitle>
        <CardDescription>Signed-in user</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        <p className="text-sm font-medium">{user?.email}</p>
        <a
          href={QUEUES_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          Queue monitor
          <ExternalLink className="size-3.5" />
        </a>
      </CardContent>
    </Card>
  );
}

export function DashboardPage() {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <HealthCard />
      <SessionCard />
    </div>
  );
}
